module.exports = __webpack_public_path__ + "img/hawala.319daeef.png";